module.exports = __webpack_public_path__ + "static/media/City Buds.e9242bf5.jpg";